import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async fetchQhses({ commit }, { pId, vId, pvId = null }) {
    Vue.$log.debug("loading qhse for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "");
    return Vue.axios.get(Vue.$url("qhse" + query)).then((rsp) => commit("SET_QHSES", rsp.data));
  },

  async fetchNextMaxCode({ commit }, { pId = null, vId = null }) {
    Vue.$log.debug("loading qhse next code for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("qhse/max-code" + query)).then((rsp) => {
      commit("SET_NEXT_SEQ_CODE", rsp.data);
      return rsp.data;
    });
  },

  async createQhse({ commit }, payload) {
    return Vue.axios.post(Vue.$url("qhse"), payload).then((rsp) => {
      Vue.$log.debug("qhse created and saved under", rsp.data.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Qhse", 1: payload.description }), { root: true });
    });
  },

  async deleteQhse({ commit }, payload) {
    Vue.$log.debug("trying to delete qhse", payload.id);
    return Vue.axios.delete(Vue.$url("qhse/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }), { root: true });
    });
  },

  async updateQhse({ commit }, payload) {
    return Vue.axios.put(Vue.$url("qhse/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Qhse", 1: payload.description }), { root: true });
    });
  },

  async updateQhseList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`qhse/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
};
